<template>
  <el-row class="warp" style="height: 100%; width: 100%">
    <el-tabs
      class="roleManagerTabBox product_management_box"
      v-model="activeName"
    >
      <el-tab-pane name="first">
        <span slot="label" style="padding: 0 15px">政策资讯</span>
        <div class="product_tab_1 outer_tab">
          <div class="pulldownbox info-container" v-show="!showQueryFilter">
            <i class="el-icon-info"></i>
            <span>查询条件</span>
            <span class="pulldownbtn" @click="pulldown"
              >展开<i class="el-icon-arrow-down"></i
            ></span>
          </div>
          <!--展开内容-->
          <div
            style="width: 100%"
            class="expandbox info-container"
            v-show="showQueryFilter"
          >
            <el-form
              class="product_filter_form"
              :model="filterForm"
              inline
              ref="filterForm"
              size="small"
              label-width="110px"
            >
              <el-form-item label="标题:">
                <el-input 
                  v-model="filterForm.titile" 
                  placeholder="请输入标题"
                  class="textInput"
                ></el-input>
              </el-form-item>
              <!--县乡村 联动-->
              <el-form-item label="适用区域:">
                <el-cascader
                  style="height: 40px"
                  class="textInput"
                  @change="liandong"
                  v-model="filterForm.qhdmValue"
                  :options="areaOptions"
                  :props="areaProps"
                  :show-all-levels="false"
                >
                </el-cascader>
              </el-form-item>
              <el-form-item label="信息类型:">
                <el-select
                  v-model="filterForm.typeDicNumber"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in infoOption"
                    :key="item.dicNumber"
                    :label="item.dicName"
                    :value="item.dicNumber"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发布时间:">
                <el-date-picker
                  v-model="filterForm.pulishTime"
                  type="date"
                  value-format="yyyyMMdd"
                  class="textInput"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-form>
            <el-row style="text-align: center; margin: 5px 0;">
              <el-button @click="queryBtnClick" type="primary" size="small"
                >查询</el-button
              >
              <el-button @click="resetFilter" type="primary" plain size="small"
                >重置</el-button
              >
              <span class="pullupbtn" @click="pullup"
                >收起<i class="el-icon-arrow-up"></i
              ></span>
            </el-row>
          </div>
          <div
            class="tablebox info-container"
            style="height: calc(100% - 20px)"
          >
            <!--总计内容-->
            <el-row class="count_content">
              <i class="el-icon-success icon-table-summary"></i>
              <span
                >共查询到<span class="count_number">{{ totalItems }}</span>
                条数据</span
              >
              <div
                style="display: inline-block; float: right; padding-right: 10px"
              >
                <el-button type="primary" size="small" @click="add()"
                  >新增</el-button
                >
              </div>
            </el-row>
            <!--table-->
            <div class="table-container">
              <el-table
                class="product_tab_1_table"
                :data="tableData"
                ref="dataTable"
                height="100%"
                highlight-current-row
              >
                <el-table-column
                  type="index"
                  align="center"
                  label="序号"
                  width="80"
                ></el-table-column>
                <el-table-column
                  prop="titile"
                  label="标题"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="qhmc"
                  label="适用区域"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="typeDicName"
                  label="信息类型"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="articleSource"
                  label="信息来源"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="viewCount"
                  label="浏览次数(次)"
                  align="center"
                ></el-table-column>
                <el-table-column prop="status" label="发布时间" align="center">
                  <template slot-scope="scope">
                    {{ timeFormat(scope.row.pulishTime) }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="pulishName"
                  label="发布人员"
                  align="center"
                ></el-table-column>
                <el-table-column label="操作" width="200" align="center">
                  <template slot-scope="scope">
                    <el-tooltip class="item" content="详情" placement="top">
                      <i
                        class="table-icon el-icon-document"
                        style="color: #00955b"
                        @click="toDetail(scope.row)"
                      ></i>
                    </el-tooltip>
                    <!-- <el-tooltip class="item" content="下载" placement="top">
                      <i
                        class="table-icon el-icon-download"
                        style="color: #00955b"
                        @click="download(scope.row)"
                      ></i>
                    </el-tooltip> -->
                    <el-tooltip class="item" content="删除" placement="top">
                      <i
                        class="table-icon el-icon-delete"
                        style="color: #00955b"
                        @click="deleteItem(scope.row)"
                      ></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!--分页工具-->
            <el-row class="page-row">
              <el-pagination
                background
                :page-size="pageSize"
                :current-page.sync="currentPage"
                @current-change="currentChange"
                layout="prev, pager, next, jumper"
                :total="totalItems"
              >
              </el-pagination>
            </el-row>
          </div>
        </div>
        <div>
          <agrotechnicalSchemeDetail
            ref="agrotechnicalSchemeDetail"
          ></agrotechnicalSchemeDetail>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-row>
</template>
<script>
import Cookies from "js-cookie";
import API_dic from "@/api/api_common";
import API_agrotechnical from "@/api/api_agrotechnical/api_agrotechnical";
import bigScreenTitleBorder from "@/components/headerTitle/bigScreenTitleBorder.vue";
import agrotechnicalSchemeDetail from "./components/details.vue";

export default {
  components: {
    bigScreenTitleBorder,
    agrotechnicalSchemeDetail,
  },

  data() {
    return {
      //区域参数
      areaOptions: null,
      areaCode: Cookies.get("curAreaCode"),
      qhdm: Cookies.get("curAreaCode"),
      areaProps: {
        label: "qhmc",
        value: "qhdm",
        children: "children",
        checkStrictly: true,
      },
      filterForm: {
        qhdmValue: [Cookies.get("curAreaCode")],
        typeDicNumber: "",
        dicNumber: "",
        title: null,
        pulishTime:null,
      },
      params: {
        qhdm: Cookies.get("curAreaCode"),
        typeDicNumber: "",
        dicNumber: "",
        category: "2",
        categorySub: "1",
        title: "",
        currentPage: 1 /*分页工具当前选中页*/,
        pageSize: 10,
      },
      selectedPlantDicNumber: "", // 条件查询栏，模糊搜索下拉框选中数据
      infoOption: [
        {
          dicName:'政策法规',
          dicNumber:'10611001'
        },
        {
          dicName:'时事要闻',
          dicNumber:'10611002'
        },
        {
          dicName:'通知公告',
          dicNumber:'10611003'
        }
      ], // 信息类型下拉数据
      agrotechTypeOption: [],
      currentPage: 1 /*分页工具当前选中页*/,
      pageSize: 10,
      totalItems: 0 /*数据总条数*/,
      ztcount: "",
      noInvestigation: "",
      showQueryFilter: true /*是否显示搜索条件*/,
      tableData: [] /*table数据源*/,
      dialogVisible: false,
      enterpriseDeptNumber: Cookies.get("enterpriseDeptNumber"),
      enterpriseNumber: Cookies.get("enterpriseNumber"),
      activeName: 'first',
    };
  },

  computed: {
    windowWidth() {
      return document.body.clientWidth;
    },
  },

  created() {
    this.getNextXzqData();
    this.GLOBAL.eventBus.$on("areaOptionsCompleted", this.getNextXzqData);
    // this.getCropList();
    this.getInfoTypeList();
    // this.getParams();
    this.getList();
    this.GLOBAL.eventBus.$on("agrotechnicalSchemeUpdated", this.resetFilter);
  },

  methods: {
    async querySearchAsync(queryString, cb) {
      let result = [];
      if (queryString) {
        let params = {
          dicName: queryString,
          categoryNumbers: ["1002", "1028"],
        };
        let { code, data } = await API_agrotechnical.getDicList(params);
        if (code == 0) {
          result = data.list.map((item) => {
            return {
              value: item.dicName,
              name: item.dicNumber,
            };
          });
        }
      }
      cb(result);
    },
    handleSelect(item) {
      console.log(item);
      this.selectedPlantDicNumber = item.name;
    },
    async getCropList() {
      // let params = {
      //   dicName: "作物",
      // };
      // let { code, data } = await API_agrotechnical.getDicList(params);
      // if (code == 0) {
      //   this.infoOption = data.list;
      // }
    },
    async getInfoTypeList() {
      // let params = {
      //   category: "1061",
      // };
      // let { code, data } = await API_dic.getDicByCategory(params);
      // if (code == 0) {
      //   this.infoOption = data.list;
      // }
    },
    getParams() {
      this.currentPage = 1;
      this.params.qhdm = this.qhdm;
      this.params.titile = this.filterForm.titile;
      this.params.typeDicNumber = this.filterForm.typeDicNumber;
      this.params.pulishTime = this.filterForm.pulishTime;
      this.params.page = this.currentPage;
    },
    getList() {
      this.params.page = this.currentPage;
      API_agrotechnical.agrotechnicalList(this.params)
        .then((res) => {
          if (res.code == 0) {
            // let tableData = [];
            // res.data.list.forEach((item) => {
            //   if (item.insureCheckRecordVo) {
            //     tableData.push(item.insureCheckRecordVo);
            //   }
            // });
            this.tableData = res.data.list;
            this.totalItems = res.data.count;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //获取区域数据
    async getNextXzqData() {
      let regionOption = localStorage.getItem("areaOptions"); //获取乡级以上区域信息
      if (regionOption) {
        this.areaOptions = [JSON.parse(regionOption)];
      }
    },

    toDetail(row) {
      console.log("row", row);
      this.$refs.agrotechnicalSchemeDetail.show(row, "detail");
    },

    add() {
      this.$refs.agrotechnicalSchemeDetail.show(null, "add");
      // if (this.enterpriseDeptNumber) {
      //   this.$refs.agrotechnicalSchemeDetail.show(null, "add");
      // } else {
      //   this.GLOBAL.warning("请先绑定组织机构！");
      // }
    },

    deleteItem(row) {
      this.$confirm("确定删除该方案？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            number: row.number,
          };
          API_agrotechnical.deleteItem(param).then((res) => {
            if (res.code == 0) {
              this.GLOBAL.success(res.msg);
              this.getList();
            } else {
              this.GLOBAL.warning(res.msg);
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    timeFormat(str) {
      let result = "--";
      if (str) {
        str = str + ""; //转为字符串
        let year = str.substring(0, 4);
        let month = str.substring(4, 6); // 转为数字，去掉前边的0
        let day = str.substring(6, 8); // 转为数字，去掉前边的0
        result = year + "-" + month + "-" + day;
      }
      return result;
    },

    download(row) {
      let param = {
        number: row.number,
      };
      API_agrotechnical.downloadItem(param).then((res) => {
        if (res) {
          this.GLOBAL.downloadBlobFile(res, row.titile, "doc");
        } else {
          this.GLOBAL.warning(res.msg);
        }
      });
    },

    //点击事件
    liandong: function (obj) {
      if (obj.length > 0) {
        this.qhdm = obj[obj.length - 1];
        // this.filterForm.qhdmValue = obj[obj.length - 1];
      }
    },

    /*分页工具换页*/
    currentChange(val) {
      this.currentPage = val;
      this.getList();
    },

    /*点击查询按钮*/
    queryBtnClick() {
      this.currentPage = 1;
      this.getParams();
      this.getList();
    },

    /*点击重置按钮*/
    resetFilter() {
      this.currentPage = 1; // 页
      this.qhdm = this.areaCode;
      this.filterForm.qhdmValue = [this.areaCode];
      this.filterForm.titile = "";
      this.filterForm.typeDicNumber = "";
      this.filterForm.pulishTime = "";

      this.getParams();
      this.getList();
    },

    /*收起按钮*/
    pullup() {
      this.showQueryFilter = false;
    },

    /*展开按钮*/
    pulldown() {
      this.showQueryFilter = true;
    },
  },
  beforeDestroy() {
    this.GLOBAL.eventBus.$off("agrotechnicalSchemeUpdated", this.resetFilter);
    this.GLOBAL.eventBus.$off("areaOptionsCompleted", this.getNextXzqData);
  },
};
</script>
<style lang="less" scoped>
.count_content__record {
  display: inline-block;
  margin-left: 10px;
}

.add {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}

.myline {
  color: black;
}

.myInput /deep/ .el-input__inner {
  width: 90px;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.left {
  display: flex;
  align-items: flex-start;
}
.right {
  display: flex;
  align-items: flex-start;
  margin-right: 50px;
}
.front {
  width: 90px;
  text-align: left;
  margin-right: 5px;
}
.rightBack {
  width: 150px;
}
.imgcontet {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.showImg {
  width: 90px;
  height: 60px;
  margin-right: 10px;
}

.myDialog /deep/ .el-dialog__header {
  background: #00955b;
}
.myDialog /deep/ .el-dialog__header .el-dialog__title {
  text-align: center;
  color: white;
  font-size: 17px;
}
.myDialog /deep/ .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
  color: white;
}

.dialogTab /deep/ .el-tabs__header {
  padding: 0;
  box-shadow: none;
}
.dialogTab /deep/ .el-tabs__nav-wrap {
  border-bottom: 1px solid #eef0f3;
}
.statistical_content {
  height: 50px;
  background: #ffffff;
  width: 100%;
  border: 1px solid #eef0f3;
  margin-top: 20px;
  // padding-top: 10px;
  display: flex;
  justify-content: space-around;
}
.statistical__record {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #373737;
  line-height: 50px;
}
.statistical_number {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #373737;
  line-height: 50px;
}
</style>




// WEBPACK FOOTER //
// src/studio/policyNews/policyNews/main.vue